import { AfterViewInit, Component, ElementRef, OnInit, Optional, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { PositionState, TooltipTheme } from './tooltip.config';
import { TooltipDirective } from './tooltip.directive';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.less']
})
export class TooltipComponent implements OnInit, AfterViewInit {
  top: number;
  left: number;
  set content(value: string | TemplateRef<unknown>) {
    this.isTemplateRef = typeof value === 'string' ? false : true;
    this._content = value;
  }
  _content :string | TemplateRef<unknown>;
  position: PositionState | string = PositionState.top;
  class: string;
  maxWidth: number;
  isTemplateRef: boolean = false;
  theme: TooltipTheme | string = TooltipTheme.black;
  hasBeak: boolean = true;

  readonly POSITION_STATE = PositionState;
  constructor(private renderer: Renderer2, @Optional() private tooltipDirective: TooltipDirective) { }

  @ViewChild('tooltip') tooltip: ElementRef;
  @ViewChild('beak') beak: ElementRef;

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    if (this.maxWidth) {
      this.renderer.setStyle(this.tooltip.nativeElement, 'max-width', `${this.maxWidth}px`);
    }
    if (this.class) {
      this.renderer.addClass(this.tooltip.nativeElement, `${this.class}`);
    }
    if (this.theme === TooltipTheme.white) {
      this.renderer.addClass(this.tooltip.nativeElement, 'tooltip--white');
      if (this.hasBeak) {
        this.renderer.addClass(this.beak.nativeElement, 'beak--white');
      }
    }
    const tooltipEl = (this.tooltip.nativeElement as HTMLElement).getBoundingClientRect();
    this.setLeft(tooltipEl.width);
    this.setTop(tooltipEl.height);
    this.renderer.setStyle(this.tooltip.nativeElement, 'top', `${this.top}px`);
    this.renderer.setStyle(this.tooltip.nativeElement, 'left', `${this.left}px`);
    if (this.hasBeak) {
      this.renderer.addClass(this.beak.nativeElement, `beak-${this.position}`)
    }
  }
  private setLeft(width: number) {
    if (this.position === PositionState.topRight || this.position === PositionState.bottomRight
      || this.position === PositionState.left || this.position === PositionState.leftBottom ||
      this.position === PositionState.leftTop) {
      this.left -= (width / 2);
    }
    if (this.position === PositionState.topLeft || this.position === PositionState.bottomLeft
      || this.position === PositionState.right || this.position === PositionState.rightBottom ||
      this.position === PositionState.rightTop) {
      this.left += (width / 2);
    }
  }
  private setTop(height: number) {
    if (this.position === PositionState.top || this.position === PositionState.topLeft ||
      this.position === PositionState.topRight || this.position === PositionState.leftBottom ||
      this.position === PositionState.rightBottom) {
      this.top -= (height / 2);
    }
    if (this.position === PositionState.bottom || this.position === PositionState.bottomLeft ||
      this.position === PositionState.bottomRight || this.position === PositionState.leftTop ||
      this.position === PositionState.rightTop) {
      this.top += (height / 2);
    }
  }
  closeTooltip() {
    this.tooltipDirective?.hide();
    this.tooltipDirective && (this.tooltipDirective.closedFromComponent = true);
  }
}
